import { Dispatch } from 'redux';
import { httpError, json, fetchGet } from 'common';
import {
  SEARCH_HISTORY_ADD,
  SEARCH_HISTORY_CLEAR,
  SEARCH_HISTORY_LOADING,
} from './SearchHistory.types';
import { UserSearchHistory } from '.';

export function searchHistoryAdd(items: UserSearchHistory[]) {
  return {
    type: SEARCH_HISTORY_ADD,
    payload: items,
  };
}

export function searchHistoryClear() {
  return {
    type: SEARCH_HISTORY_CLEAR,
  };
}

export function searchHistoryLoading(loading: boolean) {
  return {
    type: SEARCH_HISTORY_LOADING,
    payload: loading,
  };
}

export function fetchHistoryAsync(searchName: string, bearerToken: string) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;

  return (dispatch: Dispatch) => {
    dispatch(searchHistoryLoading(true));
    fetchGet(`${apiUri}/searchHistory/userSearches/${searchName}`, bearerToken)
      .then(httpError(dispatch))
      .then(json)
      .then((json: UserSearchHistory[]) => {
        dispatch(searchHistoryLoading(false));
        dispatch(searchHistoryAdd(json));
      })
      .catch((error) => {
        dispatch(searchHistoryLoading(false));
      });
  };
}
